import Component from "./InfoHide2";
export default Component;
